import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(({ spacing }) => ({
  message: {
    marginBottom: spacing(3),
  },
  duplicateMessage: {
    fontWeight: 600,
  },
}));

export default useStyles;
